module.exports = __webpack_public_path__ + "img/headshot.887f4656.jpg";